import { ModuleWithProviders } from "@angular/core";
import { Routes, RouterModule } from "@angular/router";

import { AuthGuard } from "@atenea-cms";
import { DownloadTypeListComponent } from "./download-type-list/download-type-list.component";

const routes: Routes = [
  {
    path: "download-types",
    component: DownloadTypeListComponent,
    canActivate: [AuthGuard],
  },
];

export const DownloadTypesRoutes: ModuleWithProviders = RouterModule.forChild(
  routes
);



// WEBPACK FOOTER //
// ./libs/atenea-cms-brand/src/download-types/download-types.routes.ts